import React, {useState}from "react";
import axios from "axios";
import Results from "./Results.js";
import Photos from "./Photos";
import "./Dictionary.css";

export default function Dictionary(props) {
    let [keyword, setKeyword] = useState(props.defaultKeyword);
    let [results, setResults] = useState(null);
    let [loaded, setLoaded]=useState(false);
    let [photos, setPhotos] = useState(null);

    function handleDictionaryResponse(response)   {
        
        setResults(response.data[0]);
        
    }

    function handlePexelResponse(response) {

        setPhotos(response.data.photos);

    }

    function search() {

        let apiurl = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${keyword}`;
        axios.get(apiurl).then(handleDictionaryResponse);

        let pexelApiKey = `563492ad6f91700001000001f2916c78916f40e09236b65e0d32d710`;
        let pexelApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;
        let headers = {"Authorization" : `Bearer ${pexelApiKey}`};
        axios.get(pexelApiUrl, {headers: headers }).then(handlePexelResponse);
    
    }

    function handleSubmit(event)   {

        event.preventDefault();
        search();
        
    }

    
    function handleKeywordChange(event) {
        
        setKeyword(event.target.value);
    }

    function load() {
        setLoaded(true);
        search();
    }

    if(loaded){
        return(
            <div className="Dictionary">
                <section>
                    <h1>What you are looking for </h1>
                 <form onSubmit={handleSubmit}>
                     <input type="search" onChange={handleKeywordChange} autoFocus={true} defaultValue={props.defaultKeyword}/>
                 </form>
                 <div className="hint">
                     suggested words: sunrise, stone, yoga, forest....
                 </div>
                 </section>
                 <Results results={results}/>
                 <Photos photos={photos}/>
            </div>
            );
    } else {
        load();
        return ("Loading");
    }

    
}